import { computed } from "vue";
import { useVersionAnnouncementStore } from "./version-announcement.store";
import { useUserPreferencesStore } from "../app/stores/user-preferences.store";

export function useIsLastVersionsSeen() {
  const userPreferencesStore = useUserPreferencesStore();
  const lastSeenVersion = computed(() => userPreferencesStore.lastSeenVersion);

  const versionsStore = useVersionAnnouncementStore();
  const highestVersion = computed(() => versionsStore.highestVersion?.id || 1);
  return computed(() => {
    return lastSeenVersion.value >= highestVersion.value;
  });
}
